import { DocumentCheck } from '@heroicons/react/outline';
import phase1 from "../images/DYN1.png";
import phase2 from "../images/DynNFT_phase2.png";
import phase3 from "../images/DYN3.png";

const incentives = [
    {
      name: 'Phase 1',
      description: "Pre-Event Ticket listable on our Markeplace",
      imageSrc: phase1,
    },
  
    {
      name: 'Phase 2',
      description: 'QR Code ticket granting the holder access to the Event',
      imageSrc: phase2,
    },
   
    {
      name: 'Phase 3',
      description: "Event Memorabilia listable on our Marketplace",
      imageSrc: phase3,
    },
  ]  


export default function Process() {
    return (
      <div className="bg-background">
        <div className="mx-auto py-16 sm:px-2 lg:px-4 pb-20">
        <div className="text-center mb-20">
              <h2 className="text-2xl font-title font-bold tracking-tight text-white">
                How do the Dynamic Tickets work?
              </h2>
            </div>
          <div className="mx-auto grid grid-cols-1 gap-x-20 gap-y-10 px-4 lg:max-w-none lg:grid-cols-3">
            {incentives.map((incentive) => (
              <div key={incentive.name} className="text-center sm:flex sm:text-left lg:block lg:text-center">
                <div className="sm:flex-shrink-0">
                  <div className="flow-root">
                    <img className="mx-auto h-3/4 w-2/4 rounded-lg shadow-blue shadow-2xl " src={incentive.imageSrc} alt="" />
                  </div>
                </div>
                <div className="mx-10 mt-3 sm:ml-3 lg:ml-0 lg:mt-3">
                  <h3 className="text-lg font-bold font-title text-white">{incentive.name}</h3>
                  <p className="mt-2 text-lg font-bold font-text text-white">{incentive.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
}